import types from './actionTypes';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import createReducer from '../../../util/createReducer';

const INITIAL_STATE = {
  v2: {
    filter: null,
  },
  open: false,
  filter: {
    genes: {
      orderBy: {
        statisticType: 'std',
      },
      sort: {
        asc: false,
      },
      k: 30,
      panels: {
        pam50: true,
      },
    },
    patient: {
      gender: {
        male: false,
        female: false,
        other: false,
      },
      status: {
        deceased: false,
      },
      race: {
        white: false,
        black: false,
        asian: false,
        other: false,
      },
      minAge: null,
      maxAge: null,
    },
  },
};

export default createReducer(INITIAL_STATE, {
  [types.INSIGHTS_PAGE_TOGGLE_FILTER]: (state: any, action: any) => ({
    ...state,
    open: action.open,
  }),
  [types.APPLY_FILTERS]: (state: any, action: any) => {
    return {
      ...state,
      open: false,
      filter: {
        ...action.filters,
      },
    };
  },
  [types.SET_FILTER]: (state: any, action: any) => ({
    ...state,
    v2: {
      ...state.v2,
      filter: action.filter,
    },
  }),
  [types.RESET_FILTER]: (state: any) => ({
    ...state,
    v2: {
      ...state.v2,
      filter: null,
    },
  }),
});
